// Same patterns as the api (createProspect.usecase.js): a national number of
// 10 digits starting with 0, or an international one from metropolitan France
// and the overseas territories.
const INTERNATIONAL_PHONE = /^\+(33|590|594|596|262|269|687|689)(\d{9})$/;

const keepDigitsAndPlus = (value) => String(value ?? '').replace(/[^\d+]/g, '');

export const phoneDigitCount = (value) =>
  String(value ?? '').replace(/\D/g, '').length;

export const phoneErrorCode = (value) => {
  const raw = keepDigitsAndPlus(value);
  if (!raw) return 'required';
  if (raw.startsWith('+'))
    return INTERNATIONAL_PHONE.test(raw) ? null : 'international';
  if (!raw.startsWith('0')) return 'leadingZero';
  if (raw.length < 10) return 'tooShort';
  if (raw.length > 10) return 'tooLong';
  return null;
};

// A valid international number is regrouped too: the api only strips spaces,
// dots and dashes, so "+596 (696) 12 34 56" must not reach it as typed.
export const formatPhone = (value) => {
  const raw = keepDigitsAndPlus(value);
  if (/^\d{10}$/.test(raw)) {
    return `${raw.slice(0, 4)} ${raw.slice(4, 6)} ${raw.slice(6, 8)} ${raw.slice(8, 10)}`;
  }
  const international = INTERNATIONAL_PHONE.exec(raw);
  if (international) {
    const [, dialCode, digits] = international;
    return `+${dialCode} ${digits.slice(0, 3)} ${digits.slice(3, 5)} ${digits.slice(5, 7)} ${digits.slice(7, 9)}`;
  }
  return String(value ?? '').trim();
};
